import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

// Other people's profile photos by uid, read once per person and kept for the session.
const cache = {};

export function usePhotos(uids) {
  const key = [...new Set(uids.filter(Boolean))].sort().join(',');
  const [, setTick] = useState(0);
  useEffect(() => {
    const missing = key ? key.split(',').filter(u => !(u in cache)) : [];
    if (!missing.length) return undefined;
    let live = true;
    missing.forEach(u => { cache[u] = ''; });
    Promise.all(missing.map(u => getDoc(doc(db, 'users', u))
      .then(s => { cache[u] = s.exists() ? (s.data().profilePicture || '') : ''; })
      .catch(() => {})))
      .then(() => live && setTick(t => t + 1));
    return () => { live = false; };
  }, [key]);
  return uid => cache[uid] || '';
}
